import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FooterButton } from "pro-features/components/MultiCategoriesChipDown/src/MultiCategoryChipdownStyles";

export const StyledSignalTypeApplyButton = styled(FooterButton)`
    opacity: 1;
    background-color: ${({ disabled }) => (disabled ? colorsPalettes.carbon[200] : colorsPalettes.blue[400])};
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
    pointer-events: all;
`;
